module.exports = __webpack_public_path__ + "04_medium_gold.22fe0265.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/04_medium_gold.png
// module id = 1Qis
// module chunks = 0